import React, { useEffect } from 'react';
import { StyleSheet, View, Text } from 'react-native';
import { useMediaQuery } from 'react-responsive';

import Button from 'shared/modules/common/components/atoms/Button';

type Props = {
  onReturnButtonPress: () => void;
  onNextButtonPress: () => void;
  onFocus?: () => void;
  onBlur?: () => void;
};

const PEPPrecaution = (props: Props) => {
  const { onReturnButtonPress, onNextButtonPress, onFocus, onBlur } = props;
  const isBigScreen = useMediaQuery({ minWidth: 768 });

  useEffect(() => {
    onFocus?.();

    return () => onBlur?.();
  }, []);

  return (
    <View style={styles.root}>
      <Text style={styles.mainTitle}>{`ご注意`} </Text>
      <View style={styles.content}>
        <Text
          style={styles.contentText}
        >{`外国PEPsでない方は「該当しない」を選択してください。このまま続行しますか？`}</Text>
      </View>
      <View
        style={[
          styles.buttonContainer,
          isBigScreen && styles.buttonContainerBigScreen,
        ]}
      >
        <Button
          variant="primary"
          title="続行する"
          onPress={onNextButtonPress}
          style={styles.nextButton}
          id="ekyc-pep-precaution-next-button"
        />
        <Button
          onPress={onReturnButtonPress}
          title="戻る"
          variant="outlined"
          style={styles.returnButton}
          titleStyle={styles.buttonTitle}
          id="ekyc-pep-precaution-return-button"
        />
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  root: {
    flexDirection: 'column',
    flexGrow: 1,
  },
  mainTitle: {
    fontSize: 20,
    fontWeight: '600',
    marginBottom: 24,
    color: '#000',
  },
  nextButton: {
    alignSelf: 'center',
  },
  content: {
    paddingVertical: 24,
  },
  contentText: {
    fontSize: 16,
    fontFamily: '300',
    color: '#1C1C1C',
  },
  buttonContainer: {
    flex: 1,
    flexDirection: 'column',
    flexGrow: 1,
    alignItems: 'center',
    justifyContent: 'flex-end',
    paddingTop: 12,
  },
  buttonContainerBigScreen: {
    paddingTop: 48,
    justifyContent: 'center',
  },
  returnButton: {
    marginTop: 18,
    paddingVertical: 8,
    paddingHorizontal: 8,
  },
  buttonTitle: {
    fontSize: 12,
  },
});

export default PEPPrecaution;
